export default __webpack_public_path__ + "fonts/AvenirNext-UltraLight-11.ttf";